import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Globe } from 'lucide-react';
import { useLanguage } from '@/App';
import { Button } from '@/components/ui/button';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { language, toggleLanguage } = useLanguage();

  const navItems = {
    tr: [
      { path: '/', label: 'Ana Sayfa' },
      { path: '/about', label: 'Hakkımızda' },
      { path: '/services', label: 'Hizmetlerimiz' },
      { path: '/projects', label: 'Referanslar' },
      { path: '/certificates', label: 'Sertifikalar' },
      { path: '/career', label: 'Kariyer' },
      { path: '/faq', label: 'SSS' },
      { path: '/blog', label: 'Blog' },
      { path: '/contact', label: 'İletişim' },
    ],
    en: [
      { path: '/', label: 'Home' },
      { path: '/about', label: 'About' },
      { path: '/services', label: 'Services' },
      { path: '/projects', label: 'References' },
      { path: '/certificates', label: 'Certificates' },
      { path: '/career', label: 'Career' },
      { path: '/faq', label: 'FAQ' },
      { path: '/blog', label: 'Blog' },
      { path: '/contact', label: 'Contact' },
    ],
  };

  const currentNavItems = navItems[language];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-lg border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img src="/ener-logo.png" alt="Ener Otomasyon" className="h-10 w-auto" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {currentNavItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                  location.pathname === item.path
                    ? 'bg-blue-50 text-blue-600'
                    : 'text-gray-600 hover:text-blue-600 hover:bg-gray-50'
                }`}
                data-testid={`nav-${item.path.slice(1) || 'home'}`}
              >
                {item.label}
              </Link>
            ))}

            {/* Language Toggle */}
            <Button
              variant="ghost"
              size="sm"
              onClick={toggleLanguage}
              className="ml-2"
              data-testid="language-toggle"
            >
              <Globe className="w-4 h-4 mr-1" />
              {language === 'tr' ? 'EN' : 'TR'}
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100"
            data-testid="mobile-menu-toggle"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            {currentNavItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-all mb-1 ${
                  location.pathname === item.path
                    ? 'bg-blue-50 text-blue-600'
                    : 'text-gray-600 hover:text-blue-600 hover:bg-gray-50'
                }`}
                data-testid={`mobile-nav-${item.path.slice(1) || 'home'}`}
              >
                {item.label}
              </Link>
            ))}
            <Button
              variant="ghost"
              onClick={toggleLanguage}
              className="w-full justify-start mt-2"
              data-testid="mobile-language-toggle"
            >
              <Globe className="w-4 h-4 mr-2" />
              {language === 'tr' ? 'English' : 'Türkçe'}
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;